/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/executor/components/ExecutorWorkspaceTable.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Executor Workspace
 *
 * DESCRIPTION:
 * Displays executor assigned work in a responsive
 * Bootstrap table.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Display work list
 * ✓ Navigate to Work Details
 * ✓ Empty State
 *
 ******************************************************************************/

import React from "react";
//import { useNavigate } from "react-router-dom";

export default function ExecutorWorkspaceTable({

    rows = [],

    loading = false,
    onExecute,
    onComments,


}) {

    //const navigate = useNavigate();

    if (loading) {

        return (

            <div className="card shadow-sm">

                <div className="card-body text-center py-5">

                    <div className="spinner-border text-primary" />

                    <div className="mt-3">

                        Loading Workspace...

                    </div>

                </div>

            </div>

        );

    }

    if (rows.length === 0) {

        return (

            <div className="card shadow-sm">

                <div className="card-body text-center py-5">

                    <i
                        className="fas fa-check-circle text-success fa-3x mb-3"
                    />

                    <h5>

                        No Work Found

                    </h5>

                    <div className="text-muted">

                        No work matches the selected filters.

                    </div>

                </div>

            </div>

        );

    }

    return (

        <div className="card shadow-sm border-0">

            <div className="card-header">

                <div className="d-flex justify-content-between align-items-center">

                    <h5 className="mb-0">

                        My Work

                    </h5>

                    <span className="badge bg-primary">

                        {rows.length} Works

                    </span>

                </div>

            </div>

            <div className="table-responsive">

                <table className="table table-hover align-middle mb-0">

                    <thead className="table-light">

                        <tr>

                            <th>Priority</th>

                            <th>Work No</th>

                            <th>Title</th>

                            <th>Status</th>

                            <th>Due Date</th>

                            <th style={{width:180}}>

                                Progress

                            </th>

                            <th>Owner</th>

                            <th>Approver</th>

                            <th>Team</th>

                            <th>Updated</th>

                            <th className="text-end">

                                Action

                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            rows.map((row) => (

                                <tr key={row.id}>

                                    <td>

                                        <span className={`badge rounded-pill ${
                                            row.priority === "CRITICAL"
                                                ? "bg-danger"
                                                : row.priority === "HIGH"
                                                ? "bg-warning text-dark"
                                                : row.priority === "MEDIUM"
                                                ? "bg-info text-dark"
                                                : "bg-success"
                                        }`}>

                                            {row.priority}

                                        </span>

                                    </td>

                                    <td>

                                        <strong>

                                            {row.work_no}

                                        </strong>

                                    </td>

                                    <td>

                                        {row.title}

                                    </td>

                                    <td>

                                        <span className="badge bg-secondary">

                                            {row.status}

                                        </span>

                                    </td>

                                    <td>

                                        {row.due_date}

                                    </td>

                                    <td>

                                        <div className="progress">

                                            <div

                                                className="progress-bar"

                                                style={{
                                                    width:
                                                    `${row.progress}%`
                                                }}

                                            >

                                                {row.progress}%

                                            </div>

                                        </div>

                                    </td>

                                    <td>

                                        {row.owner}

                                    </td>

                                    <td>

                                        {row.approver}

                                    </td>

                                    <td>

                                        {row.team}

                                    </td>

                                    <td>

                                        {row.updated_at}

                                    </td>

                                    
                                    <td className="text-end">

                                        <div className="btn-group">

                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={() => onExecute?.(row.id)}
                                            >
                                                {
                                                    row.status === "ASSIGNED"
                                                        ? "Start"
                                                        : row.status === "COMPLETED"
                                                        ? "View"
                                                        : "Continue"
                                                }
                                            </button>

                                            <button
                                                className="btn btn-sm btn-outline-secondary"
                                                title="Comments"
                                                onClick={() => onComments?.(row)}
                                            >
                                                <i className="fas fa-comments"></i>
                                            </button>

                                        </div>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

}
